// 256GB - 2.56e11 Bytes - https://support.google.com/youtube/answer/71673?hl=en&ref_topic=9257439
const MAX_FILE_SIZE = 2.56e11;

export { MAX_FILE_SIZE };
